export default {"src":"/_next/static/media/info.e34301f6.svg","height":23,"width":22,"blurWidth":0,"blurHeight":0};